import React, { useState } from "react";
import "./Newsletter.css";
import useRevealOnIntersect from "../hooks/useRevealOnIntersect";

function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  useRevealOnIntersect(".nl-reveal", { threshold: 0.18 });

  function handleSubmit(event) {
    event.preventDefault();

    if (!email.trim()) {
      setStatus("Enter an email address to continue.");
      return;
    }

    const subject = encodeURIComponent("Nexite Newsletter Signup");
    const body = encodeURIComponent(`Please add this email to the Nexite newsletter list:\n\n${email.trim()}`);
    window.location.href = `mailto:info.nexite@gmail.com?subject=${subject}&body=${body}`;
    setStatus("Your email app has been opened to complete the signup request.");
  }

  return (
    <section id="newsletter" className="newsletter">
      <div className="newsletter-container">
        <div className="newsletter-copy nl-reveal" data-reveal="up" style={{ "--d": "40ms" }}>
          <span className="newsletter-pill">Stay in the loop</span>
          <h2 className="newsletter-title">Get practical updates from Nexite, not inbox noise.</h2>
          <p className="newsletter-subtitle">
            Product updates, deployment insights, and technology notes shaped for decision-makers and delivery teams.
          </p>

          <div className="newsletter-points">
            <span>Security and infrastructure insights</span>
            <span>Project and rollout highlights</span>
            <span>Low-volume, useful communication</span>
          </div>
        </div>

        <form className="newsletter-form nl-reveal" data-reveal="up" style={{ "--d": "120ms" }} onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            required
            aria-label="Email Address"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <button type="submit">Request Signup</button>
        </form>

        {status ? <p className="newsletter-status">{status}</p> : null}
      </div>
    </section>
  );
}

export default NewsletterSection;